import React from 'react';

type HelpMenuClassicContextType = {
	Changeboarding: (...props: any) => JSX.Element;
};

const HelpMenuClassicContext: React.Context<HelpMenuClassicContextType | undefined> =
	React.createContext<HelpMenuClassicContextType | undefined>(undefined);

export { HelpMenuClassicContext };
